module.exports = __webpack_public_path__ + "img/symbol_3.19ace6ff.png";